import { ContextsByType } from 'contexts/base/BaseContext'

class AuthorizationProxy{

  get store(){
    return ContextsByType.users[0].state
  }

  get userId(){
    return this.user.id
  }

  get user(){
    const user = this.store.currentUser || {}
    return user
  }

  get canRead(){
    return this.user.roles.includes('read') || this.canWrite
  }

  get canWrite(){
    return this.user.roles.includes('write')
  }

  get isDeveloper(){
    return this.user.roles.includes('development')
  }

  get isAdmin(){
    return this.user.roles.includes('admin')
  }
}

export const Authorization = new AuthorizationProxy()
